import Vue from "vue";
import VueRouter from "vue-router";
import ApplicationForm from "../views/ApplicationForm.vue";
import StudentLogin from "../views/StudentLogin.vue";
import SuccessForm from "../views/paymentSuccess.vue";
import NewRegistration from "../views/NewRegistration.vue";
import Payment from "../views/Payment.vue";
import DebIdEntryOptions from "@/views/DebIdEntryOptions.vue";
import paymentOptions from "@/views/paymentOptions.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "StudentLogin",
    component: StudentLogin,
  },
  {
    path: "/register",
    name: "ApplicationForm",
    component: ApplicationForm,
  },
  {
    path: "/success",
    name: "SuccessForm",
    component: SuccessForm,
  },
  {
    path: "/registration",
    name: "NewRegistration",
    component: NewRegistration,
  },
  {
    path: "/applicant-payment",
    name: "Payment",
    component: Payment,
  },
  {
    path: "/user-entry",
    name: "DebIdEntryOptions",
    component: DebIdEntryOptions,
  },
  {
    path: "/payment-options",
    name: "Payment Options",
    component: paymentOptions,
  },
  {
    path: "*",
    redirect: "/registration",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
